import { FeatureNames } from '@/lib/featureFlags'
import { useFeatureFlags } from '@/hooks/use-feature-flags'

export function useHyperlineFeature(): boolean {
  const { isFeatureEnabled } = useFeatureFlags()
  return isFeatureEnabled(FeatureNames.hyperline)
}
